import { percentFormat } from '@/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_50 } from '@/lib/gridElements/size';
import { X } from '@/lib/socialProfile';

import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementRateHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.twitter.avg_engagement_rate_history',
    tooltip: 'chart.twitter.avg_engagement_rate_history_tooltip',
    id: 'average_engagement_rate_history',
    margin: { left: -30, bottom: 25, right: 10 },
    name: {
        date: 'date',
        value: 'chart.twitter.avg_engagement_rate_history_name'
    },
    social: X,
    color: {
        value: 'green'
    },
    valueFormat: percentFormat,
    size: SIZE_50,
    type: 'chart',
    isXAxisDate: true,
    element: LineChart
};
